import { render, staticRenderFns } from "./RmpDocumentsStep.vue?vue&type=template&id=f7c3b6e0"
import script from "./RmpDocumentsStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDocumentsStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports